import { Link, Stack, Typography, useTheme } from "@mui/material";
import { useProfileSettingsPageAccountSectionT } from "src/translation-hooks/profile-settings-page-account-section";
import { useLoginPageT } from "src/translation-hooks/login-page";
import { DekoxIcon, getContactPersonPermissions, usePermissionsTranslation } from "src/components";
import { hasValueAndNotEmpty } from "@itk/typescript-utils";
import { useGetContactPersonDetail } from "src/hooks/use-get-contact-person-detail/use-get-contact-person-detail";

const ProfileInfo = () => {
  const theme = useTheme();
  const profileSettingsPageAccountSectionT = useProfileSettingsPageAccountSectionT();
  const loginPageT = useLoginPageT();

  const { getPermissionTranslation } = usePermissionsTranslation();

  const { contactPersonDetail } = useGetContactPersonDetail();

  return (
    <Stack flex={1}>
      <Stack spacing={10} marginTop={2}>
        {/* Profile Features */}

        <Stack spacing={4}>
          {/* Profile Features */}
          <Stack spacing={1}>
            <Stack direction="row" spacing={1} alignItems="center">
              <DekoxIcon icon="account" sx={{ color: theme.palette.customColors.darkGrey }} />
              <Typography variant="body2" sx={{ color: theme.palette.customColors.darkGrey }} fontWeight={600}>
                {profileSettingsPageAccountSectionT.availableForYourProfile}
              </Typography>
            </Stack>
            <Stack spacing={1} paddingLeft={4}>
              {hasValueAndNotEmpty(contactPersonDetail) &&
                Object.values(getContactPersonPermissions())
                  .sort((x, y) => getPermissionTranslation(x).localeCompare(getPermissionTranslation(y)))
                  .filter(x => contactPersonDetail.permissions.includes(x))
                  .map((permission, index) => (
                    <Stack key={index} direction="row" spacing={1} alignItems="center" sx={{ marginLeft: 2, color: theme.palette.customColors.darkGrey }}>
                      <DekoxIcon icon="check" fontSize="small" />
                      <Typography variant="subtitle1">{getPermissionTranslation(permission)}</Typography>
                    </Stack>
                  ))}
              {/* TODO-ADAR: This button doesn't have any use as of now. */}
              {/* <Box>
                <Button
                  variant="outlined"
                  field="requestAccess"
                  t={profileSettingsPageAccountSectionT}
                  k={profileSettingsPageAccountSectionK}
                  sx={{ fontWeight: "600", border: `2px solid ${theme.palette.primary.main}` }}
                />
              </Box> */}
            </Stack>
          </Stack>

          {/* Login Information */}
          <Stack spacing={1}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ color: theme.palette.customColors.darkGrey }}>
              <DekoxIcon icon="login" />
              <Typography variant="body2" fontWeight={600}>
                {loginPageT.login}
              </Typography>
            </Stack>
            <Stack paddingLeft={4} spacing={1} sx={{ color: theme.palette.customColors.darkGrey }}>
              <Link href={`mailto:${contactPersonDetail?.email}`} underline="none" target="_blank">
                <Typography display="flex" gap={1} alignItems="center" variant="subtitle1" sx={{ marginLeft: 2 }}>
                  <DekoxIcon fontSize="small" icon="mail" /> {contactPersonDetail?.email}
                </Typography>
              </Link>
              {/* TODO-ADAR: This button doesn't have any use as of now. */}
              {/* <Box>
                <Button
                  variant="outlined"
                  field="editLogin"
                  t={profileSettingsPageAccountSectionT}
                  k={profileSettingsPageAccountSectionK}
                  sx={{ fontWeight: "600", border: `2px solid ${theme.palette.primary.main}` }}
                />
              </Box> */}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
export default ProfileInfo;
